import refIsCallback from './refIsCallback.js';

function mergeRef(refA, refB) {
  return function (element) {
    var mutableRefA = refA;
    var mutableRefB = refB;
    if (mutableRefA) {
      if (refIsCallback(mutableRefA)) {
        mutableRefA(element);
      } else {
        mutableRefA.current = element;
      }
    }
    if (mutableRefB) {
      if (refIsCallback(mutableRefB)) {
        mutableRefB(element);
      } else {
        mutableRefB.current = element;
      }
    }
  };
}

export { mergeRef as default };
//# sourceMappingURL=mergeRef.js.map
